export const LOGIN_SUCCESS_PARAM = 'success_login=1';
export const LOGOUT_PATH = '/logout';
